// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"modal_modalBody__3DIyJ","textareaDisc":"modal_textareaDisc__g95ZZ","crossSvg":"modal_crossSvg__jTpgY"};